import { render } from "./NiceId.vue?vue&type=template&id=f13538a8"
import script from "./NiceId.vue?vue&type=script&lang=js"
export * from "./NiceId.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__